import { createSlice } from "@reduxjs/toolkit";
import { getUserAboutMe } from "../Actions/User";

const initialState = {
  isLoading: true,
  data: null,
  message: "",
};
const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    saveUser: (state, user) => {
      state.data = user.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUserAboutMe.pending, (state) => {
        state.isLoading = true;
        state.message = "Pending";
      })
      .addCase(getUserAboutMe.fulfilled, (state, action) => {
        state.isLoading = false;
        state.message = "Get data successfully";
        state.data = action.payload;
      })
      .addCase(getUserAboutMe.rejected, (state) => {
        state.isLoading = false;
        state.message = "Something went wrong. Please check";
        state.data = null;
      });
  },
});
export const { saveUser } = userSlice.actions;
export default userSlice.reducer;
